import React from 'react';
import { ReachButton } from '../ReachButton/ReachButton';
import { AccentedText } from '../AccentedText/AccentedText';
import './TextContent.scss';
import { processLink } from '../../shared/processLink';
import { useLayoutContext } from '../../providers/LayoutProvider';

export const TextContent = ({
    node,
    className,
}: {
    node: any;
    className?: string;
}) => {
    if (!node) {
        return <></>;
    }
    const { nodeLookup } = useLayoutContext();
    const heading = node.field_heading;
    const eyebrow = node.field_eyebrow_text;
    const text =
        node.field_content_text?.value || node.field_body_copy_content?.value;
    const children = node.children;
    const links = node.field_link;

    return (
        <div className={`c--text-content ${className ? className : ``}`}>
            {(heading || eyebrow) && (
                <h2>
                    {eyebrow && <span className="eyebrow">{eyebrow}</span>}
                    {heading && (
                        <span>
                            <AccentedText>{heading}</AccentedText>
                        </span>
                    )}
                </h2>
            )}
            {text && (
                <div
                    className="body"
                    dangerouslySetInnerHTML={{ __html: text }}
                ></div>
            )}
            {children && <section className="children">{children}</section>}
            {links && links.length > 0 && (
                <div className="buttons">
                    {links
                        .filter((link) => link)
                        .map((link, idx) => (
                            <ReachButton
                                buttonStyle={
                                    idx === 0 ? `primary` : `secondary`
                                }
                                key={idx}
                                href={processLink(link.uri, nodeLookup)}
                            >
                                {link.title}
                            </ReachButton>
                        ))}
                </div>
            )}
        </div>
    );
};
